import React, { useEffect } from "react";
import { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";
import { Request } from "@xt/xtbase";
import store from "store";
import { getOrigin } from "utils/method";
import { get_symbol } from "api/server/market";
import { get_currencyInfoOne } from "api/server/balance";
import { get_tdk } from "api/server/tdk";
import TradeLayout from "../index";
import SpotTrade from "components/pages/trade";

interface Props {
  tdk?: any;
  locale?: string;
  symbol: string;
  pageUrl: string;
  currencyInfo?: any;
  /** 静态导出时不能从 getStaticProps 返回 redirect，改为返回目标路径由客户端跳转 */
  redirectTo?: string;
}

const SpotTradePage: React.FC<Props> = ({ symbol, currencyInfo, pageUrl, locale, tdk, redirectTo }) => {
  const router = useRouter();
  useEffect(() => {
    if (redirectTo) {
      router.replace(redirectTo);
      return;
    }
  }, [redirectTo, router]);

  console.log("%c【Page Spot Trade render】", "color:#00aecc", { symbol, currencyInfo, pageUrl, locale, tdk });
  // 设置现货币对（不带_cfd后缀）
  const spotSymbol = symbol.endsWith("_cfd") ? symbol.replace("_cfd", "") : symbol;
  store.market.updateStateOnce({ name: spotSymbol });
  store.currency.updateStateOnce({ currencyInfo: currencyInfo });

  if (redirectTo) {
    return null;
  }

  return (
    <TradeLayout>
      <SpotTrade />
    </TradeLayout>
  );
};

export default SpotTradePage;

export const getStaticPaths: GetStaticPaths = async () => {
  console.log("getStaticPaths Spot Trade");
  const paths: {
    params: {
      symbol: string;
    };
  }[] = [];

  // 默认路径
  paths.push({ params: { symbol: "btc_usdt" } });

  console.log(paths);

  return {
    paths,
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  console.log("getStaticProps Spot Trade");

  const symbol = params && typeof params.symbol === "string" ? params.symbol : "";
  // Next.js i18n 配置中 defaultLocale 是 "default"
  const targetLocale = locale || "default";
  const defaultDestination = `/${targetLocale}/trade/spot/btc_usdt`;

  if (!symbol) {
    console.log("symbol undefined, return redirectTo for client redirect");
    return {
      props: {
        symbol: "btc_usdt",
        pageUrl: "/trade/spot/btc_usdt",
        locale: targetLocale,
        redirectTo: defaultDestination,
      },
      revalidate: 60,
    };
  }

  const pageUrl = `/trade/spot/${symbol}`;
  const props: Props = {
    symbol,
    locale: targetLocale,
    pageUrl,
  };

  //symbol
  !global.xtSymbols && (global.xtSymbols = { symbols: [] });
  console.log(symbol + " global.xtSymbols.version", global.xtSymbols.version);
  const symbolRet = await Request.XtAxios.asyncAwait(get_symbol, {
    params: {
      version: global.xtSymbols.version,
    },
    headers: { "Accept-Encoding": "identity" },
  });
  console.log("server get_symbol Spot over", symbolRet.err ? "error" : "success", !symbolRet.err ? symbolRet.data.version : "");
  if (!symbolRet.err && symbolRet.data) {
    if (symbolRet.data.version !== global.xtSymbols.version) {
      global.xtSymbols = symbolRet.data;
      console.log(symbol + " global.xtSymbols.version-new", global.xtSymbols.version);
    }
  }
  const currentSymbolConfig = global.xtSymbols.symbols.find((obj) => obj.symbol === symbol);
  if (symbol !== "btc_usdt" && (!currentSymbolConfig || currentSymbolConfig.displayLevel === "NONE")) {
    console.log(`Spot symbol ${symbol} not find, return redirectTo for client redirect`);
    return {
      props: {
        symbol: "btc_usdt",
        pageUrl: "/trade/spot/btc_usdt",
        locale: targetLocale,
        redirectTo: defaultDestination,
      },
      revalidate: 60,
    };
  }

  //tdk
  const tdkUrl = getOrigin("www") + "/" + targetLocale + pageUrl;
  console.log("start req tdk", tdkUrl);
  const tdkRet = await Request.XtAxios.asyncAwait(get_tdk, {
    params: {
      url: tdkUrl,
    },
  });
  console.log("TDK=======", tdkRet.err ? "error" : "success", tdkUrl);
  if (!tdkRet.err && tdkRet.data) {
    props.tdk = tdkRet.data;
    console.log(tdkRet.data);
  }
  //获取币种介绍列表
  const currency = symbol.split("_")[0].toLowerCase();
  const currencyInfoRet = await Request.XtAxios.asyncAwait(get_currencyInfoOne, currency);
  console.log("currencyInfo=======", currencyInfoRet.err ? "error" : "success", currency);
  if (!currencyInfoRet.err && currencyInfoRet.data) {
    props.currencyInfo = currencyInfoRet.data;
  }

  return {
    props,
    revalidate: 60,
  };
};
